import { render } from "./TimeSlots.vue?vue&type=template&id=47297e7c"
const script = {}

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__